import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import { ROLE } from '../../../auth'
import { UserModel } from '../../../auth/core/_models'
import { IsGranted } from '../../../auth/PrivateRoute'
import { ROLE_NAME } from '../../../../../constants'
import { EmployeeProfile } from '../../core/_models'
import { getEmployeeProfile } from '../../api'
import { MerchantAccess } from '../../components/MerchantAccess'

const OPERATOR_MERCHANT_ROLES: ROLE[] = [
  ROLE.ROLE_OPERATOR,
  ROLE.ROLE_SENIOR_OPERATOR,
  ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
]

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Активные',
    path: '/staff/active',
    isSeparator: false,
    isActive: false,
    roles: [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER],
  },
]

const displayRoles = (roles: string[]) =>
  roles
    .filter((r) => r !== 'ROLE_USER')
    .map((r) => ROLE_NAME[r] || r)
    .sort()
    .join(', ')

export const StaffProfile = () => {
  const { uuid } = useParams<{ uuid: string }>()
  const [profile, setProfile] = useState<EmployeeProfile | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const load = async () => {
      if (!uuid) return
      setLoading(true)
      try {
        const res = await getEmployeeProfile(uuid)
        if (res.data?.success && res.data.data) {
          setProfile(res.data.data)
          setError(null)
        } else {
          setError('Сотрудник не найден')
        }
      } catch (err) {
        setError('Не удалось загрузить профиль сотрудника')
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [uuid])

  // Reuse the hierarchy-aware role check against the profile subject's roles.
  const isOperator =
    !!profile &&
    IsGranted(OPERATOR_MERCHANT_ROLES, { roles: profile.roles } as unknown as UserModel)

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Профиль сотрудника</PageTitle>

      {loading && (
        <div className='card'>
          <div className='card-body'>Загрузка...</div>
        </div>
      )}

      {!loading && error && (
        <div className='card'>
          <div className='card-body text-danger'>{error}</div>
        </div>
      )}

      {!loading && profile && (
        <>
          <div className='card'>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title fw-bold fs-3'>{profile.uuid}</h3>
            </div>
            <div className='card-body py-3'>
              <div className='row mb-4'>
                <div className='col-3 text-muted'>ID</div>
                <div className='col-9 fw-bold'>{profile.id}</div>
              </div>
              <div className='row mb-4'>
                <div className='col-3 text-muted'>UUID</div>
                <div className='col-9'>{profile.uuid}</div>
              </div>
              <div className='row mb-4'>
                <div className='col-3 text-muted'>Роли</div>
                <div className='col-9'>{displayRoles(profile.roles)}</div>
              </div>
              <div className='row mb-4'>
                <div className='col-3 text-muted'>Активен</div>
                <div className='col-9'>{profile.enabled ? 'Да' : 'Нет'}</div>
              </div>
              <div className='row mb-4'>
                <div className='col-3 text-muted'>Создан</div>
                <div className='col-9'>{profile.createdAt}</div>
              </div>
              <div className='row mb-4'>
                <div className='col-3 text-muted'>Обновлён</div>
                <div className='col-9'>{profile.updatedAt}</div>
              </div>
              <div className='row mb-4'>
                <div className='col-3 text-muted'>Постоянный токен</div>
                <div className='col-9'>{profile.authTokenPersistent ? 'Да' : 'Нет'}</div>
              </div>
            </div>
          </div>

          {isOperator && <MerchantAccess employee={profile} onChanged={setProfile} />}
        </>
      )}
    </>
  )
}
